export const DateRangeChangeDirection = {
  Left: -1,
  Right: 1,
  Today: 2
};

// Date range options 
export const SeizureReportDateRange = {
  Custom: 0,
  Last7Days: 1,
  Last30Days: 2,
  ThisMonth: 3,
  LastMonth: 4,
  Last90Days: 5,
  Last6Months: 6,
  ThisYear: 7,
  Today: 8,
  Yesterday: 9,
  ThisWeek: 10
};

// Optional: mapping for display names
export const SeizureReportDateRangeDisplay = {
  [SeizureReportDateRange.Custom]: "Custom Range",
  [SeizureReportDateRange.Last7Days]: "Last 7 Days",
  [SeizureReportDateRange.Last30Days]: "Last 30 Days",
  [SeizureReportDateRange.ThisMonth]: "This Month",
  [SeizureReportDateRange.LastMonth]: "Last Month",
  [SeizureReportDateRange.Last90Days]: "Last 90 Days",
  [SeizureReportDateRange.Last6Months]: "Last 6 Months",
  [SeizureReportDateRange.ThisYear]: "This Year",
  [SeizureReportDateRange.Today]: "Today",
  [SeizureReportDateRange.Yesterday]: "Yesterday",
  [SeizureReportDateRange.ThisWeek]: "This Week"
};

export const SeizureTypeReportRangeType = {
  Daily: 0,
  Weekly: 1,
  Monthly: 2
};